import React from 'react';
import '../styles/Employees.css';

function formatDate(value) {
  if (!value) return null;
  if (value?.toDate) return value.toDate().toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  if (value?.seconds) return new Date(value.seconds * 1000).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  const d = new Date(value);
  if (!isNaN(d)) return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  return null;
}

function EmployeesSection({ 
  approvedEmployees,
  teams,
  sortedTeams,
  filteredEmployees,
  employeeFilter,
  employeeSearch,
  setEmployeeFilter,
  setEmployeeSearch,
  handleMoveEmployee,
  handleRemoveEmployee
}) {
  return (
    <>
      <div className="dashboard-header">
        <div>
          <h1>Employees</h1>
          <p>All approved employees in your company</p>
        </div>
      </div>

      {approvedEmployees.length === 0 ? (
        <div className="empty-state">
          <p>No employees yet. Approve pending requests to add employees.</p>
        </div>
      ) : (
        <>
          <div className="employee-filter">
            <div className="filter-group">
              <label>Filter by Team:</label>
              <select 
                value={employeeFilter}
                onChange={(e) => setEmployeeFilter(e.target.value)}
                className="filter-select"
              >
                <option value="all">All Teams</option>
                {sortedTeams.map(team => (
                  <option key={team.id} value={team.id}>{team.name}</option>
                ))}
              </select>
            </div>
            <div className="filter-group">
              <label>Search:</label>
              <input
                type="text"
                value={employeeSearch}
                onChange={(e) => setEmployeeSearch(e.target.value)}
                placeholder="Search by name or email..."
                className="search-input"
              />
            </div>
            <span className="filter-count">
              {filteredEmployees.length} employee{filteredEmployees.length !== 1 ? 's' : ''}
            </span>
          </div>

          <div className="employees-list">
            <div className="employees-table">
              <table>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Current Team</th>
                    <th>Joined</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredEmployees.map(employee => {
                    const team = teams.find(t => t.id === employee.teamId);
                    const joined = formatDate(employee.approvedAt) || formatDate(employee.createdAt);
                    return (
                      <tr key={employee.id}>
                        <td>{employee.name || 'N/A'}</td>
                        <td>{employee.email}</td>
                        <td>
                          <span className="team-badge">
                            {team ? team.name : 'No Team'}
                          </span>
                        </td>
                        <td>{joined || '-'}</td>
                        <td>
                          <div className="action-buttons">
                            <select
                              className="move-select-table"
                              defaultValue=""
                              onChange={(e) => {
                                if (e.target.value) {
                                  handleMoveEmployee(employee.id, e.target.value);
                                  e.target.value = '';
                                }
                              }}
                            >
                              <option value="">Move to...</option>
                              {sortedTeams.filter(t => t.id !== employee.teamId).map(t => (
                                <option key={t.id} value={t.id}>{t.name}</option>
                              ))}
                            </select>
                            <button
                              className="remove-button"
                              onClick={() => {
                                if (window.confirm(`Remove ${employee.name || employee.email} from your company?`)) {
                                  handleRemoveEmployee(employee.id);
                                }
                              }}
                              title="Remove employee"
                            >
                              ✕
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default EmployeesSection;
